module.exports = __webpack_public_path__ + "static/media/EmotionTriste.3268082d.jpg";